

class SizeGuideDrawer extends Drawer {
    
    constructor() {
        super();
        this.isDesktop = window.innerWidth > 1024;

    }

    setListeners() {
        super.setListeners()
        document.querySelectorAll('[data-size-guide]').forEach(opener => this.setIconAccessibility(opener));
    }

    connectedCallback() {
        this.onBikiniUpdate = subscribe(PUB_SUB_EVENTS.onBikiniConfiguratorUpdate, (event) => {
           this.setListeners()
        });
    }

    disconnectedCallback() {
        this.onBikiniUpdate && this.onBikiniUpdate()
    }

    open() {
        super.open()
        this.setContentHeight()
    }

    setContentHeight() {
        const drowerHeaderH = this.querySelector('.drawer__header').offsetHeight ;
        const drowerContentH = parseInt(window.innerHeight - drowerHeaderH);
        this.querySelector('[data-content]').style.maxHeight = `${drowerContentH || 0}px`
    }

}

customElements.define('size-guide-drawer', SizeGuideDrawer);